import React from 'react';
import { Radio, RadioGroup } from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { AppI18n } from '../../../../i18n';
import { spacingForControls, timeCommitments, TimeCommitmentType, useBudgetAndTimelineContext } from '../utils';

export const TimeCommitmentSelector = () => {
  const { setSectionContentState, sectionContentState } = useBudgetAndTimelineContext();

  const onTimeCommitmentChange = (selected: string) => {
    setSectionContentState({
      ...sectionContentState,
      timelineDetails: {
        ...sectionContentState.timelineDetails,
        timeCommitment: selected as TimeCommitmentType,
      },
    });
  };

  return (
    <Stack direction="column">
      <Stack>
        <Text size="b_md" fontWeight="semibold">
          <AppI18n k={'sections.budget_and_timeline.time_commitment.title'} />
        </Text>
      </Stack>
      <RadioGroup
        value={sectionContentState.timelineDetails?.timeCommitment}
        name="time-commitment"
        onChange={onTimeCommitmentChange}
      >
        {Object.entries(timeCommitments).map(([commitmentKey, commitmentValue]) => (
          <Radio key={commitmentKey} value={commitmentValue} className={spacingForControls}>
            <Text size="b_sm">
              <AppI18n k={`sections.budget_and_timeline.time_commitment.${commitmentValue}`} />
            </Text>
          </Radio>
        ))}
      </RadioGroup>
    </Stack>
  );
};
